var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 2.29166C8.50419 2.29166 7.29163 3.50422 7.29163 4.99999C7.29163 6.49576 8.50419 7.70832 9.99996 7.70832C11.4957 7.70832 12.7083 6.49576 12.7083 4.99999C12.7083 3.50422 11.4957 2.29166 9.99996 2.29166ZM6.04163 4.99999C6.04163 2.81386 7.81383 1.04166 9.99996 1.04166C12.1861 1.04166 13.9583 2.81386 13.9583 4.99999C13.9583 7.18612 12.1861 8.95832 9.99996 8.95832C7.81383 8.95832 6.04163 7.18612 6.04163 4.99999Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 18.3333C1.875 13.846 5.5127 10.2083 10 10.2083C14.4873 10.2083 18.125 13.846 18.125 18.3333C18.125 18.6785 17.8452 18.9583 17.5 18.9583C17.1548 18.9583 16.875 18.6785 16.875 18.3333C16.875 14.5364 13.7969 11.4583 10 11.4583C6.20305 11.4583 3.125 14.5364 3.125 18.3333C3.125 18.6785 2.84518 18.9583 2.5 18.9583C2.15482 18.9583 1.875 18.6785 1.875 18.3333Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/my-account.c741842751894e0773e6d605a265e7f4.svg";
export { ForwardRef as ReactComponent };